module.exports = __webpack_public_path__ + "static/media/postman1.12b8ee77.png";